import React from "react";
import { getTimeZoneName } from "@hex-insights/core";
import { User, useUserUpdateMutation } from "../../../Utilities";

export function useSetUserTimeZoneName(userID: User["id"] | null | undefined) {
	let timeZoneName = "";
	try {
		timeZoneName = getTimeZoneName();
	} catch {}

	const [update] = useUserUpdateMutation();
	React.useEffect(() => {
		if (!(userID && timeZoneName)) {
			return;
		}
		update({
			variables: {
				id: userID,
				input: { timeZoneName },
			},
		});
	}, [userID, timeZoneName, update]);
}
